<template>
  <div
    v-if="trustedBrands.length"
    class="trusted-brands m-auto w-full overflow-hidden flex-col flex justify-center"
  >
    <h2
      v-if="title"
      class="brand-header text-center text-EXPONDO-black text-xl mx-auto mb-10 font-bold leading-7 px-5
      w-full md:px-0 md:text-3xl md:leading-10"
    >
      {{ title }}
    </h2>
    <div
      v-show="showCarousel"
      class="brand-images mx-auto"
    >
      <SimpleCarousel
        :slider-items="trustedBrands"
        :slides-auto-width="true"
        :hide-arrows-on-boundaries="true"
        :arrows="true"
        :height="48"
        :gap="48"
        :wrapper-classes="'overflow-hidden mx-20 flex items-center'"
        :slide-class="'flex-none flex h-6 justify-center items-center'"
      >
        <template #default="{ currentItem }">
          <TrustedBrandItem
            :brand-url="currentItem.url"
            :brand-title="currentItem.title"
            :brand-image="currentItem.logo.url"
          />
        </template>
      </SimpleCarousel>
    </div>
    <div
      v-show="!showCarousel"
      class="brand-images overflow-hidden m-auto w-full relative flex flex-col gap-5 px-5"
    >
      <TrustedBrandItem
        v-for="brand in trustedBrands"
        :key="brand.title"
        :brand-url="brand.url"
        :brand-title="brand.title"
        :brand-image="brand.logo.url"
      />
    </div>
  </div>
</template>

<script lang="ts">

import type { TrustedBrand } from '~~/types/cms/TrustedBrand';
import SimpleCarousel from '~/components/molecules/SimpleCarousel/SimpleCarousel.vue';
import TrustedBrandItem from '~/components/molecules/TrustedBrandItem/TrustedBrandItem.vue';
import { OUR_BRANDS_KEYS } from '~~/constants/brands';
import { getBrandInfo } from '~~/helpers/brand';


export default defineComponent({
  name: 'TrustedBrands',
  components: {
    TrustedBrandItem,
    SimpleCarousel,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  setup() {

    const { isMobile } = useUiMode();
    const { getBrandSearchPageUrl } = useBrandPage();

    const trustedBrands = computed<TrustedBrand[]>(() => {

      return OUR_BRANDS_KEYS.map((brandKey) => {

        const brandInfo = getBrandInfo(brandKey);

        if (!brandInfo) {

          return;
        
        }

        return {
          title: brandInfo.name,
          url: getBrandSearchPageUrl(brandInfo, true),
          logo: { url: brandInfo.logo },
        };
      
      }).filter((brand): brand is TrustedBrand => Boolean(brand));
    
    });

    const showCarousel = computed(() => {

      return !isMobile.value;
    
    });

    return {
      showCarousel,
      trustedBrands,
    };
  
  },
});
</script>

<style scoped lang="scss">
.trusted-brands {
  .brand-images,
  .brand-header {
    max-width: var(--container-max-width);
  }
}
</style>
